import { render, staticRenderFns } from "./create-or-edit-subscription.vue?vue&type=template&id=b0267968"
import script from "./create-or-edit-subscription.ts?vue&type=script&lang=js&external"
export * from "./create-or-edit-subscription.ts?vue&type=script&lang=js&external"
import style0 from "./create-or-edit-subscription.vue?vue&type=style&index=0&id=b0267968&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports